import {ActionBrick, registerBrick, ErrorFlow, CloudObject} from 'olympe';
import {getLogger} from '@olympeio/core';
import {convertExcelSheetToObjects, createMappingFromBusinessObject, validateInputs} from './dataFormatHandlers';

export default class ExcelSheetToObjects extends ActionBrick {
    /**
     * @override
     */
    init($) {
        this.logger = getLogger('ExcelSheetToObjects');
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} excelSheet
     * @param {*} businessObject
     * @param {Map} mapping
     * @param {boolean} automaticDiscovery
     * @param {string} range
     * @param {function()} forwardEvent
     * @param {function(ListDef)} setObjects
     * @param {function(*)} setErrorFlow
     */
    async update($, [excelSheet, businessObject, mapping, automaticDiscovery, range], [forwardEvent, setObjects, setErrorFlow]) {
        try {
            validateInputs(businessObject, mapping, automaticDiscovery, range);

            if (!excelSheet && typeof excelSheet !== 'object') {
                throw new Error(`Invalid excelSheet: "${excelSheet}"`);
            }

            if (automaticDiscovery) {
                mapping = createMappingFromBusinessObject(businessObject);
            }

            const objects = await convertExcelSheetToObjects(excelSheet, range, mapping, businessObject);

            setObjects(objects.map((tag) => CloudObject.get(tag)));
            forwardEvent();
        } catch (error) {
            this.logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error, 0));
        }
    }
}

registerBrick('018f0f2c89bbfba391db', ExcelSheetToObjects);
